import { Box, Paper, styled } from '@mui/material';

/** The chips and the search field, wrapping onto a new line when they run out of room. */
export const PickerContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: theme.spacing(1),
  minWidth: 0
}));

/** The result list's paper, with room above the type chips that head it. */
export const PickerPaper = styled(Paper)(({ theme }) => ({
  paddingTop: theme.spacing(2)
}));

/**
 * Above the results: the type chips, wrapping onto a next line rather than running out of the list, which
 * is only as wide as the search field.
 */
export const PickerPaperHeader = styled(Box)({
  '& > *': {
    flexWrap: 'wrap',
    // The chip row is 100% wide plus its padding; without this it overflows the list by that padding.
    boxSizing: 'border-box'
  }
});

/**
 * The round icon of a plan unit, sized like the entity icons beside it — in the option rows, and
 * `compact` in the chips. Exported as `SelectionChipIcon` for the other chips a page lists with the picked
 * ones.
 */
export const OrganizationalUnitIcon = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'compact'
})<{ compact?: boolean }>(({ theme, compact }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: theme.spacing(compact ? 5 : 7),
  height: theme.spacing(compact ? 5 : 7),
  borderRadius: theme.spacing(compact ? 4 : 2),
  backgroundColor: theme.vars.palette.secondary.container,
  color: theme.vars.palette.secondary.onContainer,
  '& svg': compact ? { fontSize: theme.typography.caption.fontSize } : {}
}));
